import { route, string } from "react-router-typesafe-routes";

export const ROUTES_CONFIG = {
    AUTH: route({
        children: {
            LOGIN: route({
                path: "login",
                children: {
                    DEMO: route({
                        path: "demo"
                    })
                }
            }),
            LOGOUT: route({
                path: "logout",
            }),
            REGISTER: route({
                path: "register",
                searchParams: {
                    token: string().defined()
                }
            }),
            FORGOT_PASSWORD: route({
                path: "forgot-password",
            }),
            RESET_PASSWORD: route({
                path: "reset-password",
                searchParams: {
                    token: string()
                }
            }),
        }
    }),
    
    APP: route({
        children: {
            DASHBOARD: route({
                path: "dashboard",
            }),
            PLAYER_DB: route({
                path: "player-db",
            }),
            SHORTLIST: route({
                path: "shortlist",
            }),
            LONGLIST: route({
                path: "longlist",
            }),
            PLAYER_DETAIL: route({
                path: "player/:player_id",
                params: {
                    player_id: string().defined()
                }
            }),
            CLUB_DB: route({
                path: "club-db",
            }),
            CLUB_DETAIL: route({
                path: "club/:club_id",
                params: {
                    club_id: string().defined()
                }
            }),
            MATCHES:route({
                path: "matches",
            }),
            MATCH_DETAIL: route({
                path: "match/:match_id",
                params: {
                    match_id: string().defined()
                }
            }),
            TASKS: route({
                path: "tasks",
            }),
            REPORTS: route({
                path: "reports",
            }),
            CONTACTS: route({
                path: "contacts",
                children: {
                    DETAIL: route({
                        path: ":contact_id",
                        params: {
                            contact_id: string().defined()
                        },
                        children: {
                            OFFERED_PLAYER_ID: route({
                                path: ":offered_player_id",
                                params: {
                                    offered_player_id: string().defined()
                                }
                            })
                        }
                    })
                }
            }),
            USER_MANAGEMENT: route({
                path: "user-management",
            }),
        }
    }),

    WEB: route({
        children: {
            HOME: route({
                path: ""
            })
        }
    })
} as const;